var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-wrapper",
        { staticClass: "form-wrapper", attrs: { validator: _vm.$v.model } },
        [
          _c(
            "form-group",
            { attrs: { label: "Client Id", name: "clientId" } },
            [
              _c("md-input", {
                model: {
                  value: _vm.model.clientId,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.model,
                      "clientId",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "model.clientId",
                },
              }),
            ],
            1
          ),
          _c(
            "form-group",
            { attrs: { label: "Client Secret", name: "clientSecret" } },
            [
              _c("md-input", {
                model: {
                  value: _vm.model.clientSecret,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.model,
                      "clientSecret",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "model.clientSecret",
                },
              }),
            ],
            1
          ),
          _c(
            "form-group",
            { attrs: { label: "Webhook Secret", name: "webhookSecret" } },
            [
              _c("md-input", {
                model: {
                  value: _vm.model.webhookSecret,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.model,
                      "webhookSecret",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "model.webhookSecret",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }